import { render } from "./Serving-Georgia.vue?vue&type=template&id=70a2397c"
import script from "./Serving-Georgia.vue?vue&type=script&lang=js"
export * from "./Serving-Georgia.vue?vue&type=script&lang=js"

import "./Serving-Georgia.vue?vue&type=style&index=0&id=70a2397c&lang=scss"

import exportComponent from "/codebuild/output/src3279127340/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__